import { IAlert, IAlertAction } from '../types/alert.types';
import { HIDE_ALERT, SHOW_ALERT } from '../constants/ActionTypes';

export const showAlert = (payload: IAlert): IAlertAction => ({
  type: SHOW_ALERT,
  payload,
});

export const hideAlert = () => ({
  type: HIDE_ALERT,
});
